import React from 'react';
import IconArrowDown from "../IconArrowDown"; // Global States for faster scheduling

import { useStore } from "../../contexts/store";
import Metric from "../../telemetry";

const Duration = () => {
  const {
    state,
    dispatch
  } = useStore();
  const {
    duration
  } = state;
  const style = window && window.outerWidth < 768 ? {
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none'
  } : {};
  return /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: window && window.outerWidth < 768 ? {
      position: 'relative'
    } : {}
  }, /*#__PURE__*/React.createElement("select", {
    onChange: e => {
      dispatch({
        type: 'UPDATE',
        payload: {
          duration: parseInt(e.target.value)
        }
      });
      Metric.interviewDurationChange(parseInt(e.target.value));
    },
    className: "selectDuration",
    name: "duration",
    value: duration // @ts-ignore
    ,
    style: style
  }, /*#__PURE__*/React.createElement("option", {
    value: 30
  }, "30 minutes"), /*#__PURE__*/React.createElement("option", {
    value: 60
  }, "60 minutes"), /*#__PURE__*/React.createElement("option", {
    value: 90
  }, "90 minutes"), /*#__PURE__*/React.createElement("option", {
    value: 120
  }, "120 minutes")), window && window.outerWidth < 768 && /*#__PURE__*/React.createElement(IconArrowDown, {
    style: {
      right: 20,
      top: 3
    }
  })));
};

export default Duration;